import CONF from '../utils/conf';
import u from '../utils/Utils';
import du from '../utils/dom-utilities';


/**
 * Calc bottom height and apply margin at the page
 *
 * @param {HTMLElement} page
 * @param {HTMLElement} bottom
 */
function _defineMargin(page, bottom) {
    let style = bottom.getBoundingClientRect();
    page.style.marginBottom = (parseInt(style.height) || 0) + 'px';
}

/**
 * Unset margin at page
 *
 * @param {HTMLElement} page
 */
function _undefineMargin(page) {
    page.style.marginBottom = '0px';
}

/**
 * Check window width and define the margin bottom
 *
 * @param {HTMLElement} page
 * @param {HTMLElement} bottom
 */
function _checkMq(page, bottom){
    if (Modernizr.mq(`(min-width: ${u.em(CONF.mq.lg)}em)`)){
        _defineMargin(page, bottom);
    } else {
        _undefineMargin(page);
    }
}

/**
 * Apply bottom effect at a page depends of his bottom
 *
 * @export
 * @param {string} pageSelector
 * @param {string} bottomSelector
 */
export default function(pageSelector, bottomSelector) {
    let page = document.querySelector(pageSelector),
        bottom = document.querySelector(bottomSelector);

    if (page !== null && bottom !== null) {
        _checkMq(page, bottom);

        du.onEvent(window, 'load', () => { // Called a second time at load
            _checkMq(page, bottom);
        });

        du.onEvent(window, 'optimized-resize', () => {
            _checkMq(page, bottom);
        });
    }

};



// WEBPACK FOOTER //
// ./src/main/js/components/bottomEffect.js